import { cloneDeep } from 'lodash';

export const updateEventBooking = ({
  event, type, isOfferedLive, isOfferedPreMatch,
}) => {
  const updatedEvent = cloneDeep(event);
  if (type === 'booked') {
    updatedEvent.bookedEvents = { nodes: [{ isOfferedLive, isOfferedPreMatch }] };
  } else if (type === 'un-booked') {
    updatedEvent.bookedEvents = { nodes: [{ isOfferedLive: false, isOfferedPreMatch: false }] };
  } else if (type === 'sgp-booked') {
    updatedEvent.bookedSameGameParlays = { nodes: [{ isOfferedLive, isOfferedPreMatch }] };
  } else if (type === 'sgp-un-booked') {
    updatedEvent.bookedSameGameParlays = { nodes: [{ isOfferedLive: false, isOfferedPreMatch: false }] };
  } else if (type === 'pp-booked') {
    updatedEvent.bookedPlayerProps = { nodes: [{ isOfferedLive, isOfferedPreMatch }] };
  } else if (type === 'pp-un-booked') {
    updatedEvent.bookedPlayerProps = { nodes: [{ isOfferedLive: false, isOfferedPreMatch: false }] };
  } else if (type === 'micro-booked') {
    updatedEvent.bookedMicroMarkets = { nodes: [{ isOfferedLive, isOfferedPreMatch }] };
  } else if (type === 'micro-un-booked') {
    updatedEvent.bookedMicroMarkets = { nodes: [{ isOfferedLive: false, isOfferedPreMatch: false }] };
  }
  return updatedEvent;
};
